function isUndef(type) {
  return type === 'undefined';
}
export var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);